import React from 'react';
import PropTypes from 'prop-types';
import { useTranslation } from 'react-i18next';

const CommunityName = ({ value }) => {
  const { t } = useTranslation();

  return <span>{value || t('global')}</span>;
};

CommunityName.propTypes = { value: PropTypes.string };
CommunityName.defaultProps = { value: undefined };

export default CommunityName;
